exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-70da7744] {\n  margin-bottom: 5px !important;\n}", ""]);

// exports
